import {useAppDispatch, useAppSelector} from "app/hooks";
import {CommentType} from "components/CommentCard/CommentCard";
import {
  selectCommentRecentLikeds,
  selectCommentRecentRemoveds,
  removeLikedByPostId,
  addNewLikedByPostId,
} from "app/commentLikes/commentLikes";
import CommentCardLikeReply, {
  CommentCardLikeReplyProps,
} from "components/CommentCardLikeReply/CommentCardLikeReply";
import React, {FC} from "react";
import {deleteDoc, doc, increment, serverTimestamp, setDoc, updateDoc} from "firebase/firestore";
import {auth, db} from "../../configs/firebase-config";
import {displayToast, toastType} from "../../global/Functions";

export interface CommentCardLikeReplyContainerProps
  extends Pick<CommentCardLikeReplyProps, "onClickReply"> {
  className?: string;
  comment: CommentType;
  postId?: string
  userId?: string
}

const CommentCardLikeReplyContainer: FC<CommentCardLikeReplyContainerProps> = ({
                                                                                 className = "",
                                                                                 comment,
                                                                                 postId,
                                                                                 userId,
                                                                                 ...args
                                                                               }) => {
  const {like, id} = comment;

  const recentLikeds = useAppSelector(selectCommentRecentLikeds);
  const recentRemoveds = useAppSelector(selectCommentRecentRemoveds);
  const dispatch = useAppDispatch();

  const postDocRef = doc(db, "posts", `${userId}/posts/${postId}`);
  const commentDocRef = doc(db, "posts", `${userId}/posts/${postId}/comments/${comment.id}`);
  const commentLikeDocRef = doc(db, "comment-hearts", `${userId}_${postId}_${comment.id}`);

  const isLiked = () => {
    if (recentLikeds.includes(id)) {
      return true;
    }
    return like.isLiked && !recentRemoveds.includes(id);

  };

  const getLikeCount = (): number => {
    // Recent Liked
    // if (recentLikeds.includes(id)) {
    //   return like.count + 1;
    // }
    // if (like.isLiked && recentRemoveds.includes(id)) {
    //   return like.count - 1;
    // }
    return like.count;
  };

  const handleClickLike = async () => {
    if (isLiked()) {
      if (!auth.currentUser) {
        displayToast("Log in to leave a like", toastType.info);
        return;
      }
      await deleteDoc(commentLikeDocRef);
      await updateDoc(commentDocRef, {heartCount: increment(-1)});
      await updateDoc(postDocRef, {priority: increment(-3)});
      dispatch(removeLikedByPostId(id));
    } else {
      if (!auth.currentUser) {
        displayToast("Log in to leave a like", toastType.info);
        return;
      }

      await setDoc(commentLikeDocRef, {postId, userId, commentId: comment.id, likedAt: serverTimestamp()});
      await updateDoc(commentDocRef, {heartCount: increment(1)});
      await updateDoc(postDocRef, {priority: increment(3)});
      dispatch(addNewLikedByPostId(id));
    }
  };

  return (
    <CommentCardLikeReply
      className={className}
      onClickLike={handleClickLike}
      commentId={id}
      isLiked={isLiked()}
      likeCount={getLikeCount()}
      {...args}
    />
  );
};

export default CommentCardLikeReplyContainer;
